<script setup>
import { dateZhCN, lightTheme, NConfigProvider, zhCN } from 'naive-ui'
import { shuffle, merge } from 'lodash-es'

const themeOverrides = {
  common: {
    primaryColor: '#0084FFFF',
    primaryColorHover: '#0084FFFF',
  },
  Button: {
    colorWarning: '#FF7B00',
    // "heightMedium": "48px"		
  },
  Menu: {
    borderColorHorizontal: '#0084FFFF'
  }
}
</script>

<template>
  <grid>
    <n-message-provider>
      <n-loading-bar-provider>
        <n-notification-provider>
          <n-config-provider
            :locale="zhCN"
            :date-locale="dateZhCN"
            :theme="lightTheme"
            class="grid"
            inline-theme-disabled
            :theme-overrides="themeOverrides"
          >
            <router-view></router-view>
          </n-config-provider>
        </n-notification-provider>
      </n-loading-bar-provider>
    </n-message-provider>
  </grid>
</template>

<style>
canvas {
  display: block;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  position: relative;
}

body {
  color: #666666;
}
#app {
  display: grid;
}

* {
  outline: none;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
}
</style>
